<template>
  <div
    :ref="generateSafeId(fieldQuestionId, 'wrapper')"
    class="RMPE-DynamicField"
    :class="{ 'RMPE-HasError': fieldHasError }"
  >
    <component
      :is="layout.type"
      :image="layout.image"
      :video="layout.video"
    >
      <div
        class="field"
      >
        <div class="control">
          <label
            class="label RMPE-DynamicField-Label"
            :for="fieldQuestionId"
          >
            <span
              :class="{'RMPE-Required': question.required}"
              v-html="question.formattedLabel"
            />
          </label>

          <HintMessage :hint="question.formattedDescription" />

          <MediaMiddlePartial :layout="layout" />
          <div
            @dragover.prevent
            @drop="dragFile"
          >
            <label
              ref="auto-focus-target"
              tabindex="0"
              :for="fieldQuestionId"
              class="RMPE-FileUploadField-dropzone input-container"
              @keydown.space.prevent="$refs['auto-focus-target'].click()"
              @keydown.enter="submitWithEnter"
            >
              <span class="icon is-right"><font-awesome-icon :icon="icon" /></span>
              <span style="display: block">Drag and drop or click here to upload file.</span>
              <span style="display: block">Max file size is {{
                question.options.maxFileSizeInMB
              }}MB</span>

              <span
                v-if="file !== null"
                class="RMPE-FileUploadField-dropzone-divider"
              />

              <span
                v-if="file !== null"
                style="display: block"
              >Selected file: <em>{{ file.name }}</em></span>
              <span
                v-if="file !== null"
                style="display: block"
              >File size: <em>{{ maxFileSizeAllowed(file.size) }}</em></span>
            </label>

            <input
              :id="fieldQuestionId"
              :ref="getFieldQuestionId()"
              type="file"
              class="input"
              :class="{ 'is-danger': fieldHasError }"
              autocomplete="off"
              :accept="acceptedFileTypes(question)"
              @change="handleFileUpload"
            >

            <ErrorMessage
              :field-has-error="fieldHasError"
              :errors="error.errors"
              :is-blurred="isBlurred"
            />
          </div>
          <div class="RMPE-DynamicForm-SubmitContainer">
            <button
              :disabled="isNextButtonDisabled"
              class="button is-primary RMPE-CustomSubmit"
              @click="goToNextQuestion"
            >
              {{ question.goToNextQuestionButtonLabel }}
            </button>
            <span
              v-if="!isTouchDevice"
              class="RMPE-CustomSubmit-Hint"
            >
              press <span class="is-family-code has-text-weight-bold ">Enter</span> <kbd>↵</kbd>
            </span>
          </div>
        </div>
      </div>
    </component>
  </div>
</template>
<script>
import DynamicFieldMixin from '../../mixins/dynamic-field-mixin';
import FileUploadFieldMixin from '../common/file-upload-field';

export default {
  mixins: [DynamicFieldMixin, FileUploadFieldMixin],
};
</script>

<style scoped lang="scss">

.is-right {
  height: 2.5em;
  pointer-events: none;
  position: absolute;
  top: 0;
  width: 2.5em;
  z-index: 4;
  right: 0;
}

.RMPE-FileUploadField-dropzone-divider {
  margin: 15px;
  border-top: var(--text-answer-color) 1px dotted;
  height: 1px;
  display: block
}

.RMPE-FileUploadField-dropzone {
  //color: var(--form-font-color);
  padding: 30px 30px;
  margin-bottom: 20px;
  text-align: center;
  display: block;
  border: 1px dashed;
  border-radius: 5px;
  cursor: pointer;

  &:hover,
  &:focus {
    border-color: transparent;
  }
}

input {
  display: none;
}

.drop-area {
  border: 2px dashed #ccc;
  border-radius: 20px;
  width: 480px;
  font-family: sans-serif;
  margin: 100px auto;
  padding: 20px;
}

.drop-area.highlight {
  border-color: purple;
}
</style>
